<template>
    <div class="index-page">
        <div class="content-box">
            <div class="content">
                <div class="menu flex">
                    <div @click="toNextPage(item)" :style="{background:item.background}" v-for="item in menu" :key="item.name" class="item flex">
                        <img :src="item.icon"/>
                        <div>
                            <div class="title">{{item.name}}</div>
                            <div class="tips">{{item.tips}}</div>
                        </div>
                    </div>
                </div>
                 <el-carousel height="320px">
                    <el-carousel-item v-for="item,index in banner" :key="index">
                         <el-image
                            style="width: 100%; height: 100%"
                            :src="item.url"
                            fit="cover"></el-image>
                    </el-carousel-item>
                </el-carousel>
                <div class="dynamic">
                    <div>
                        <dynamicTitle title="协会要闻" :link="{ path: '/associationNews/news' }"></dynamicTitle>
                        <div @click="toDetails(item,'associationNewsNews')" class="pointer news-item" v-for="item,i in news" :key="i">
                            <div class="left">
                                <div class="title">{{item.day}}</div>
                                <div class="date">{{item.date}}</div>
                            </div>
                            <div class="right hidden1">{{item.title}}</div>
                        </div>
                        <el-empty v-if="news.length==0" description="暂无内容"></el-empty>
                    </div>
                    <div class="industry">
                        <dynamicTitle title="行业动态" :link="{ path: '/associationNews/industryTrends'}"></dynamicTitle>
                        <div @click="toDetails(item,'associationNewsIndustryTrends')" class="dynamic-item flex pointer" v-for="item in industryTrends" :key="item.title">
                           <div class="hidden1"> {{item.title}}</div>
                        </div>
                        <el-empty v-if="industryTrends.length==0" description="暂无内容"></el-empty>
                        <!-- <div v-if="industryTrends.length>0&&industryTrends.length<10" class="noMore">没有更多了</div> -->
                    </div>
                    <div>
                        <dynamicTitle title="协会通知" :link="{ path: '/associationNews/notice' }"></dynamicTitle>
                        <div @click="toDetails(item,'associationNewsNotice')" class="news-item pointer" v-for="item in notice" :key="item.title">
                            <div class="left">
                                <div class="title">{{item.day}}</div>
                                <div class="date">{{item.date}}</div>
                            </div>
                            <div class="right hidden1">{{item.title}}</div>
                        </div>
                        <el-empty v-if="notice.length==0" description="暂无内容"></el-empty>
                    </div>
                    <div>
                        <dynamicTitle title="培训课程" :link="{ path: '/associationNews/training'}"></dynamicTitle>
                         <div @click="toCourseDetails(item)" class="dynamic-item flex-between pointer" v-for="item in training" :key="item.title">
                            <div style="flex:1" class="hidden1">{{item.title}}</div>
                            <div class="date">{{item.date}}</div>
                        </div>
                        <el-empty v-if="training.length==0" description="暂无内容"></el-empty>
                    </div>
                    <div>
                        <dynamicTitle title="培训通知" :link="{ path: '/associationNews/trainingNotice'}"></dynamicTitle>
                        <div @click="toDetails(item,'associationNewsTrainingNotice')" class="dynamic-item flex-between pointer" v-for="item in trainingNotice" :key="item.title">
                            <div style="flex:1" class="hidden1">{{item.title}}</div>
                            <div class="date">{{item.date}}</div>
                        </div>
                         <el-empty v-if="trainingNotice.length==0" description="暂无内容"></el-empty>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dynamicTitle from '@/components/dynamicTitle.vue'
import {dynamics,queryForm} from '@/api/api.js'
import {getTrainingList}from '@/api/course.js'
import {mapMutations} from 'vuex'
import {findRoute} from '@/utils/routerHelper.js'
export default {
    components:{
        dynamicTitle
    },
    data(){
        return{
            menu:[
                {
                    name:'培训报名',
                    tips:'社工培训报名',
                    icon:require('@/assets/index/baoMing.png'),
                    background:'#EBECFF',
                    queryObj:{
                        path:'/associationNews',
                        query: { tabsName: '培训报名' }
                    }
                },
                {
                    name:'培训通告',
                    tips:'培训通知与通告',
                    icon:require('@/assets/index/tongGao.png'),
                    background:'#DBEDFF',
                    queryObj:{
                        path:'/associationNews',
                        query: { tabsName: '培训通知' }
                    }
                },
                {
                    name:'人才招聘',
                    tips:'培训通知与通告',
                    icon:require('@/assets/index/zhaoPing.png'),
                    background:'#D9E8FF',
                    queryObj:{
                        path:'/memberService',
                        query: { tabsName: '会员招聘' }
                    }
                },
                 {
                    name:'会员中心',
                    tips:'协会会员中心',
                    icon:require('@/assets/index/huiYuan.png'),
                    background:'#FFF3D5',
                    queryObj:{
                        path:'/memberCenter'
                    }
                },
            ],
            banner:[
                // {
                //     url:'https://smartserver-file.oss-cn-chengdu.aliyuncs.com/huaCheng/banner3.jpg'
                // },
                // {
                //     url:'https://smartserver-file.oss-cn-chengdu.aliyuncs.com/huaCheng/banner4.png'
                // }
            ],
            news:[],
            notice:[],
            training:[],
            trainingNotice:[],
            industryTrends:[]
        }
    },
    created(){
        this.addRouterHistory()
        this.getBanner()
        this.getInfo(8)
        this.getInfo(9,15)
        this.getInfo(10)
        this.getInfo(11)
        this.getData()
    },
    methods:{
         ...mapMutations('routerData', ['changeRouterList']),
         getBanner(){
            queryForm(
                {
                formKey: "b9DtZu1i",
                queryId: "282",
                queryParams: {
                    workflowStatus: "通过"
                },
                size: 20,
                current: 0
                }
            ).then(res=>{
                if(res.data.code==200){
                    this.banner=res.data.data.rows.map(v=>{
                        v.url=v.image_upload1768891930068&&v.image_upload1768891930068[0]?v.image_upload1768891930068[0].url:''
                        return v
                    })
                }
            })
        },
        toDetails(data,name){
            this.$router.push(
                { path: '/associationNews/details',query: { id: data.id } }
            )
            let routerList=[]
            let routers = ['index',name, '/associationNews/details'];
            for (let i = 0; i < routers.length; i++) {
                let routerData=findRoute(this.$router.options.routes, routers[i])
                routerList.push(routerData)
            }
            this.changeRouterList(routerList)
        },
        toCourseDetails(data){
            this.$router.push(
                { path: '/associationNews/courseDetails',query: { id: data.id } }
            )
            let routerList=[]
            let routers = ['index','associationNewsTraining', '/associationNews/courseDetails'];
            for (let i = 0; i < routers.length; i++) {
                let routerData=findRoute(this.$router.options.routes, routers[i])
                routerList.push(routerData)
            }
            this.changeRouterList(routerList)
        },
        addRouterHistory(){
            let routerList=this.$store.state.routerData.routerList
            let data=routerList.find(v=>v.name==this.$router.currentRoute.name)
            if(!data){
                routerList.push(this.$router.currentRoute)
                this.changeRouterList(routerList)
            }
        },
        getInfo(type,size){
            //type: 8协会要闻 9行业动态 10协会通知 11培训通知
            dynamics({
                current:1,
                size:size || 5,
                type:type
            }).then(res=>{
                if(res.data.code==200){
                    let data=res.data.data.records.map(v=>{
                        let dateData=this.getDate(v.createTime)
                        v.date=dateData.newDates,
                        v.day=dateData.day
                        return v
                        // console.log(v.createTime.slice(0, - 3))
                        // console.log(dateData)
                    })
                    if(type==8){
                        this.news=data
                    }else if(type==9){
                        this.industryTrends=data
                    }else if(type==10){
                        this.notice=data
                    }else if(type==11){
                        this.trainingNotice=data
                    }
                }
            //    console.log(res)
            })
        },
        //课程培训
        getData(){
            getTrainingList({
                current:1,
                size:5,
            }).then(res=>{
                if(res.data.code==200){
                    this.training=res.data.data.records.map(v=>{
                        let dateData=this.getDate(v.createTime)
                        v.date=dateData.newDates,
                        v.day=dateData.day
                        v.title=v.trainingTitle
                        return v
                    })
                }
            })
        },
        toNextPage(data){
            if(this.$route.path==data.queryObj.path){
                return
            }
            if(data.queryObj){
                this.$router.push(data.queryObj)
            }
        },
        getDate(dateString){
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();

            return {
                day,
                newDates:year+'-'+(month<10?('0'+month):month)
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .index-page{
        width:100%;
        padding-bottom: 109px;
        .content{
            width:80%;
            margin:0 auto;
            .menu{
                padding:20px 0;
                gap:20px;
                .item{
                    flex:1;
                    gap:24px;
                    background: #ebecff;
                    padding:14px 40px;
                    cursor: pointer;
                    img{
                        width: 72px;
                        height: 72px;
                    }
                    .title{
                        font-size: 24px;
                        color: #222222;
                        font-weight: bold;
                    }
                    .tips{
                        font-size: 16px;
                        color: #666666;
                        margin-top:4px;
                    }
                }
            }
        }
        .dynamic{
            margin-top:32px;
            display: grid;
            /*  声明列的宽度  */
            grid-template-columns:66.66% 33.33%;
            /*  声明行间距和列间距  */
            grid-gap: 32px 20px;
            .news-item{
                height: 72px;
                border: 1px solid #f3f1ef;
                margin-top:12px;
                font-size: 20px;
                color: #333333;
                display: flex;
                .left{
                    width: 72px;
                    height: 72px;
                    background: #f3f1ef;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .title{
                        font-size: 26px;
                        text-align: center;
                        color: #666666;
                        font-weight: bold;
                    }
                    .date{
                        font-size: 12px;
                        color: #666666;
                    }
                }
                .right{
                    padding:8px 14px;
                }
            }
        }
        .dynamic-item{
            margin-top:12px;
            padding:0 16px;
            height: 54px;
            border: 1px solid #f3f1ef;
            font-size: 20px;
            color: #333333;
            .date{
                font-size: 20px;
                color: #666666;
                flex-shrink: 0;
                margin-left:10px;
            }
        }
        .industry{
            grid-column-start: 2;
            grid-column-end: 3;
            grid-row-start: 1;
            grid-row-end:3;
        }
    }
    .noMore{
        height: 54px;
        line-height: 54px;
        font-size: 20px;
        color: #333333;
        text-align: center;
    }
    .pointer{
        cursor: pointer;
    }
</style>